/*
 *  This has been generated using the Synergy STDev tool.
 *  Any modifications will be lost after the next build
 */

import { DateTimeString, date } from 'common'
export type __FORCE_MODULE__ = unknown; //We add this line so that even if the file ends up being empty, it will still be recognized as a module without impacting the bundle size.

export class ParentRecord {
  parentGU?: string;
  formattedName?: string;
  photo?: string;
}

export class ViewState {
  viewGU?: string;
  tabGU?: string;
  identity?: string;
  serverState: Record<string, string> = {};
  dataElements: Array<DataElement> = [];
  gridElements: Array<GridElement> = [];
}

export class DashboardUserInfo {
  name?: string;
}

export class RoleConfiguration {
  additionalShortcuts: Array<RoleActionDescriptor> = [];
  actions: Array<RoleActionDescriptor> = [];
  userRoles: Array<StaffRole> = [];
}

export class ViewSuggestion {
  timeSlice: DateTimeString = date.Empty;
  viewGU?: string;
  viewType?: string;
  viewIcon?: string;
  viewName?: string;
  count: number = 0;
}

export class StudentEnrollmentHistoryEntry {
  addDate?: string;
  addUserGU?: string;
  userName?: string;
  activityDate?: string;
  studentSchoolYearGU?: string;
  studentName?: string;
  gradeLevel?: string;
  gradeLevelDesc?: string;
  origin?: string;
  orgYearGU?: string;
  orgYearName?: string;
  enrollmentType?: string;
  enrollmentTypeDesc?: string;
}

export class RevResponse {
  REV_RETURN: RevReturn = new RevReturn;
  REV_DATA_ROOT: RevDataRoot = new RevDataRoot;
}

export class ICurrentClassInfo {
  studentLocationState: number = 0;
  periodAttCode?: string;
  allDayCode?: string;
  courseTitle?: string;
  room?: string;
  sectionID?: string;
  staffName?: string;
  period?: string;
  formattedPeriod?: string;
  description?: string;
  studentGU?: string;
  studentClassGUs: Array<string> = [];
}

export class StudentRecord {
  studentGU?: string;
  studentSchoolYearGU?: string;
  formattedName?: string;
  grade?: string;
  gradeDesc?: string;
  sisNumber?: string;
  photo?: string;
  focusKey?: string;
}

export class StudentEntityHistory {
  views: Array<ViewDefInfo> = [];
  students: Array<StudentEntityRecord> = [];
}

export class TwoPointSliderValue {
  lowValue: number = 0;
  highValue: number = 0;
  lowBandLegend?: string;
  midBandLegend?: string;
  highBandLegend?: string;
  minValue: number = 0;
  maxValue: number = 0;
  step: number = 0;
  enforceInteger: boolean = false;
  title?: string;
  lowBandColor?: string;
  midBandColor?: string;
  highBandColor?: string;
}

export class NyrSetupDefinitionTilesData {
  definitions: Array<NyrSetupDefinition> = [];
}

export class GradReqThresholdData {
  title?: string;
  lowValue?: number;
  highValue?: number;
  minValue: number = 0;
  maxValue: number = 0;
  enforceInteger: boolean = false;
  step: number = 0;
}

export class RowData {
  counselorGU?: string;
  studentSchoolYearGU?: string;
  grade?: string;
  gradReqDefGU?: string;
  isDiplomaType: boolean = false;
  gradReqResultGU?: string;
  classOfCredit?: string;
  classOfTest?: string;
  classOfGPA?: string;
  classOfServiceLearning?: string;
  classOfAchievements?: string;
  runDate?: string;
  result: GradReqStuJson = new GradReqStuJson;
  gradeLookups: Record<string, string> = {};
  subjectAreaLookups: Record<string, string> = {};
  districtGradePeriodLookups: Record<string, string> = {};
  requirementStatusLookups: Record<string, string> = {};
  studentGU?: string;
  studentName?: string;
  sisNumber?: string;
  calculatedGraduationRequirementsYear?: string;
  counselorName?: string;
  leaveCode?: string;
  leaveDate?: string;
  summerWithdrawlCode?: string;
  organizationName?: string;
  status: RequirementStatus = RequirementStatus.NotMet;
}

export class GradReqResultDetailHeaderData {
  studentName?: string;
  sisNumber?: string;
  photo?: string;
  organizationName?: string;
  status: RequirementStatus = RequirementStatus.NotMet;
  classOf?: string;
  graduationRequirement?: string;
  grade?: string;
}

export class SchoolIncidentSummaryData {
  schIncidentGU?: string;
  incidentID?: string;
  incidentDate?: string;
  incidentTime?: string;
  enteredByGU?: string;
  referredBy?: string;
  referredByName?: string;
  referrerType?: string;
  locations?: string;
  incidentContextCode?: string;
  description?: string;
  alcoholRelated: boolean = false;
  bullyingRelated: boolean = false;
  drugRelated: boolean = false;
  gangRelated: boolean = false;
  hateRelated: boolean = false;
  hazingRelated: boolean = false;
  injuryRelated: boolean = false;
  referLawEnforcement: boolean = false;
  unfounded: boolean = false;
  vapingRelated: boolean = false;
  weaponRelated: boolean = false;
  enableWizardViews: boolean = false;
  enableEditButton: boolean = false;
  violations: Array<ViolationData> = [];
  existingViolations: Array<string> = [];
  newlySelectedViolations: Array<string> = [];
  students: Array<StudentData> = [];
  otherPersons: Array<OtherPersonsData> = [];
}

export class StudentHallPassRestrictionsData {
  hasData: boolean = false;
  groups: Array<StudentHallPassRestrictionGroupData> = [];
}

export class StudentHallPassesData {
  hasData: boolean = false;
  inProgressPasses: Array<StuHallPassData> = [];
  passes: Array<StuHallPassData> = [];
}

export class StudentHallPassSummaryData {
  dataLoaded: boolean = false;
  countToday?: string;
  countThisWeek?: string;
  countThisMonth?: string;
  countThisSchoolYear?: string;
  hallPassStatus?: string;
  hallPassStatusIcon?: string;
  hallPassStatusIconColor?: string;
  passLimit?: string;
  passLimitIcon?: string;
  passLimitIconColor?: string;
}

export class StudentHallPassStatsData {
  dataLoaded: boolean = false;
  totalPassTime?: string;
  passesOverTimeLimit?: string;
}

export class DataElement {
  srcName?: string;
  value?: string;
  originalValue?: string;
  soundexSearch: boolean = false;
  ignoreDirectFind: boolean = false;
  condition: ElementCondition = new ElementCondition;
}

export class GridElement {
  guid?: string;
  dataElements: Array<DataElement> = [];
}

export class RoleActionDescriptor {
  ID?: string;
  description?: string;
  icon?: string;
  role: StaffRole = StaffRole.Any;
  entityType: EntityType = EntityType.None;
  showActiveInactive?: number;
  viewGU?: string;
  tabGU?: string;
}

export enum StaffRole {
  Any = 0,
  AttendanceClerk = 1,
  Counselor = 2,
  DistrictAdmin = 3,
  DistrictStateReporting = 4,
  Nurse = 5,
  Registrar = 6,
  SchoolAdministrator = 7,
  SupportAgent = 8,
  SupportSupervisor = 9,
  SupportUser = 10,
  Unknown = 11,
}

export class RevReturn {
  RESULT?: string;
  ERROR: Array<Error> = [];
}

export class RevDataRoot {
  clientActions: Array<JSONClientAction> = [];
  REV_DATA_GROUP: RevDataGroup = new RevDataGroup;
  REV_VIEW: RevView = new RevView;
}

export class ViewDefInfo {
  viewGU?: string;
  viewNamespace?: string;
  allowReminders: boolean = false;
  viewName?: string;
  shortViewTitle?: string;
  viewIcon?: string;
  viewType?: string;
  viewUrl?: string;
  primaryBoid?: string;
  orgType?: string;
  isReport: boolean = false;
  reportGroupGU?: string;
  reportNumber?: string;
  reportName?: string;
  reportTitle?: string;
  tabs: Array<TabData> = [];
}

export class StudentEntityRecord {
  lastAccessInfo: AccessInfo = new AccessInfo;
  recentViews: Array<string> = [];
  studentGU?: string;
  studentSchoolYearGU?: string;
  formattedName?: string;
  grade?: string;
  gradeDesc?: string;
  sisNumber?: string;
  photo?: string;
  focusKey?: string;
}

export class NyrSetupDefinition {
  nyrSetupDefGU?: string;
  setupDefName?: string;
  definitionStatus?: string;
  yearToYearString?: string;
  extension?: string;
}

export class GradReqStuJson {
  studentSchoolYearGU?: string;
  gradReqDefGU?: string;
  classOf?: string;
  studentGraduated: boolean = false;
  creditData: GradReqStuCreditJson = new GradReqStuCreditJson;
  testData: GradReqStuTestJson = new GradReqStuTestJson;
  gpaData: GradReqStuGPAJson = new GradReqStuGPAJson;
  serviceLearningData: GradReqStuServiceLearningJson = new GradReqStuServiceLearningJson;
  achievementsData: GradReqStuAchievementsJson = new GradReqStuAchievementsJson;
  courseSequenceData: GradReqStuCourseSequenceJson = new GradReqStuCourseSequenceJson;
}

export enum RequirementStatus {
  NotMet = 0,
  Met = 1,
  OnTrack = 2,
  OffTrack = 3,
  AtRisk = 4,
  None = 5,
}

export class ViolationData {
  lookupValue?: string;
  lookupDesc?: string;
}

export class StudentData {
  participantKey?: string;
  photo?: string;
  formattedName?: string;
  motivation?: string;
  incidentRoleCode?: string;
  incidentRole?: string;
  roleDescription?: string;
  violations: Array<string> = [];
  interventions: Array<InterventionData> = [];
  dispositions: Array<DispositionData> = [];
}

export class OtherPersonsData {
  participantKey?: string;
  photo?: string;
  formattedName?: string;
  incidentRoleCode?: string;
  incidentRole?: string;
  roleDescription?: string;
  violations: Array<string> = [];
  dispositions: Array<DispositionData> = [];
}

export class StudentHallPassRestrictionGroupData {
  order: number = 0;
  restrictionGroupCode?: string;
  restrictionGroupName?: string;
  studentRestrictions: Array<StudentHallPassRestrictionData> = [];
}

export class StuHallPassData {
  hallPassGU?: string;
  dateTime?: string;
  totalMinutes: number = 0;
  totalTime?: string;
  overTimeLimit: boolean = false;
  inProgress: boolean = false;
  room: HallPassRoomData = new HallPassRoomData;
}

export class ElementCondition {
  type?: string;
  values: Array<string> = [];
}

export enum EntityType {
  None = 0,
  Student = 1,
  Parent = 2,
}

export class Error {
  CODE?: string;
  row?: string;
  message?: string;
}

export class JSONClientAction {
  actionType?: string;
}

export class RevDataGroup {
  REV_ELEMENT: Array<RevElement> = [];
}

export class RevView {
  PRIMARY_OBJECT?: string;
  GUID?: string;
  REV_TAB: RevTab = new RevTab;
}

export class TabData {
  tabGU?: string;
  tabName?: string;
}

export class AccessInfo {
  focusOrganizationGU?: string;
  focusOrganizationName?: string;
  focusYearGU?: string;
  focusSchoolYear?: string;
  timestamp?: string;
}

export class GradReqStuCreditJson {
  status: RequirementStatus = RequirementStatus.NotMet;
  gradesBySubjectArea: Record<string, GradReqStuCreditGradeJson> = {};
  creditDataByGrade: Record<string, CreditGradeData> = {};
  currentTerm: CreditThresholdGradePeriodData = new CreditThresholdGradePeriodData;
  totalRequiredCredits: number = 0;
  totalNeededCredits: number = 0;
  totalEarnedCredits: number = 0;
}

export class GradReqStuTestJson {
  status: RequirementStatus = RequirementStatus.NotMet;
  groups: Array<GradReqStuTestGroup> = [];
}

export class GradReqStuGPAJson {
  status: RequirementStatus = RequirementStatus.NotMet;
  minGPA: number = 0;
  GPA: number = 0;
  gpaDefTypeGU?: string;
  totalCreditsAttempted: number = 0;
  totalCreditsCompleted: number = 0;
  totalGradeQualityPoints: number = 0;
  totalCreditWeight: number = 0;
  totalGpaBonus: number = 0;
  waivers: Array<GradReqStuGPAWaiver> = [];
  achievementWaivers: Array<string> = [];
  courseDetails: Array<GPACourseRecord> = [];
}

export class GradReqStuServiceLearningJson {
  status: RequirementStatus = RequirementStatus.NotMet;
  requiredHours: number = 0;
  totalHours: number = 0;
  hours: Array<GradReqStuServiceLearningHour> = [];
  waivers: Array<GradReqStuServiceLearningWaiver> = [];
}

export class GradReqStuAchievementsJson {
  status: RequirementStatus = RequirementStatus.NotMet;
  achievementYearDefData: Array<AchievementYearDefData> = [];
}

export class GradReqStuCourseSequenceJson {
  sequences: Array<GradReqCourseSequence> = [];
  requiredSequences: number = 0;
  completedSequences: number = 0;
  status: RequirementStatus = RequirementStatus.NotMet;
}

export class InterventionData {
  interventionGU?: string;
  intervention?: string;
  comment?: string;
}

export class DispositionData {
  dispositionKey?: string;
  disposition?: string;
  violations: Array<string> = [];
  violationDesc?: string;
  dispositionDesc?: string;
  dispositionDate?: string;
  dispositionHours?: string;
  dispositionDays?: string;
  dispositionComment?: string;
}

export class StudentHallPassRestrictionData {
  studentName?: string;
  studentPhoto?: string;
}

export class HallPassRoomData {
  roomName?: string;
  color?: string;
  colorLight?: string;
  iconPath?: string;
}

export class RevElement {
  SRC_ELEMENT?: string;
  SRC_OBJECT?: string;
  SRC_NAME?: string;
  value?: string;
}

export class RevTab {
  GUID?: string;
  REV_GRID: RevGrid = new RevGrid;
}

export class GradReqStuCreditGradeJson {
  orgsByGradeJson: Record<string, GradReqStuCreditOrgJson> = {};
  requiredCredits: number = 0;
  completedCredits: number = 0;
  inProgressCredits: number = 0;
  forecastedCredits: number = 0;
}

export class CreditGradeData {
  grade?: string;
  completedCredits: number = 0;
  requestedCredits: number = 0;
  gradeStatus: RequirementStatus = RequirementStatus.NotMet;
  creditThresholdPeriods: Array<CreditThresholdGradePeriodData> = [];
  statusByTerm: Record<string, TermData> = {};
}

export class CreditThresholdGradePeriodData {
  gradReqUpdateCreditThresholdGU?: string;
  gradePeriod?: string;
  offTrack?: number;
  onTrack?: number;
  schoolYear?: string;
  grade?: string;
  gradePeriodDate: DateTimeString = date.Empty;
}

export class GradReqStuTestGroup {
  name?: string;
  order: number = 0;
  testType?: string;
  status?: string;
  testGU?: string;
  performanceLevel?: string;
  score?: string;
  date?: string;
}

export class GradReqStuGPAWaiver {
  comments?: string;
  date: DateTimeString = date.Empty;
  reason?: string;
}

export class GPACourseRecord {
  courseID?: string;
  gradeLevel?: string;
  termCode?: string;
  markSource: GPAFromTypeEnum = GPAFromTypeEnum.Current;
  repeatTag?: string;
  baseCredit?: string;
  academicType?: string;
  mark?: string;
  markPointValue?: string;
  gradePeriodWeight?: string;
  creditAttempted: number = 0;
  creditCompleted: number = 0;
  creditWeight: number = 0;
  gradeQualityPoints: number = 0;
  gpaBonus: number = 0;
  skipReason?: string;
}

export class GradReqStuServiceLearningHour {
  category?: string;
  hours: number = 0;
  dateEarned: DateTimeString = date.Empty;
  projectName?: string;
  schoolType?: string;
}

export class GradReqStuServiceLearningWaiver {
  achievementGU?: string;
  hours: number = 0;
}

export class AchievementYearDefData {
  evalOrder: number = 0;
  groupName?: string;
  metCondition: boolean = false;
  minimumValidCondition: number = 0;
  grade?: string;
  achievementCondition1Data: Array<AchievementCondition1Data> = [];
}

export class GradReqCourseSequence {
  name?: string;
  met: boolean = false;
  hasProgress: boolean = false;
  groups: Array<GradReqCourseSequenceGroup> = [];
}

export class RevGrid {
  GUID?: string;
  PRIMARY_OBJECT?: string;
  BEFORE_READ?: string;
  GROUP_PROPERTY_VALUE_OVERRIDE?: string;
  SCROLL_FIELDS: RevScrollFields = new RevScrollFields;
  IDENTITY: RevIdentity = new RevIdentity;
  GROUP_FIELDS: RevGroupFields = new RevGroupFields;
  REV_COLUMNS: RevColumns = new RevColumns;
  FILTER_VALUES: RevFilterValues = new RevFilterValues;
  ROWS: RevRows = new RevRows;
}

export class GradReqStuCreditOrgJson {
  creditResultsByOrg: Record<string, Array<CourseCreditResult>> = {};
}

export class TermData {
  termCode?: string;
  termName?: string;
  completedCredits: number = 0;
  inProgressCredits: number = 0;
  requestedCredits: number = 0;
  offTrack?: number;
  onTrack?: number;
  termStatus: RequirementStatus = RequirementStatus.NotMet;
}

export enum GPAFromTypeEnum {
  Current = 0,
  CrsHistory = 1,
  Unknown = 2,
}

export class AchievementCondition1Data {
  name?: string;
  groupType: GroupTypeEnum = GroupTypeEnum.And;
  metCondition: boolean = false;
  minimumValidConditions: number = 0;
  achievementCondition2Data: Array<AchievementCondition2Data> = [];
}

export class GradReqCourseSequenceGroup {
  name?: string;
  order: number = 0;
  requiredCredits?: number;
  earnedCredits: number = 0;
  met: boolean = false;
  hasProgress: boolean = false;
  courses: Array<GradReqCourseSequenceCourse> = [];
}

export class RevScrollFields {
  REV_ELEMENT: Array<RevElement> = [];
}

export class RevIdentity {
  REV_ELEMENT: RevElement = new RevElement;
}

export class RevGroupFields {
  REV_ELEMENT: Array<RevElement> = [];
}

export class RevColumns {
  REV_ELEMENT: Array<RevElement> = [];
}

export class RevFilterValues {
  VALUES: Array<RevValues> = [];
}

export class RevRows {
  ROW: Array<RevRow> = [];
}

export class CourseCreditResult {
  organiztionGU?: string;
  organizationName?: string;
  subjectArea?: string;
  cteSubjectAreas: Array<string> = [];
  districtGradePeriod?: string;
  courseGU?: string;
  courseID?: string;
  mark?: string;
  term?: string;
  dateTaken?: string;
  grade?: string;
  courseTitle?: string;
  creditsInProgress: number = 0;
  creditsCompleted: number = 0;
  creditsRequested: number = 0;
  creditsAttempted: number = 0;
  receivedNoCredit: boolean = false;
  creditType: CreditType = CreditType.CourseHistory;
  partial: boolean = false;
  partialLink: number = 0;
}

export enum GroupTypeEnum {
  And = 0,
  Or = 1,
}

export class AchievementCondition2Data {
  name?: string;
  achievementGU?: string;
  groupType: GroupTypeEnum = GroupTypeEnum.And;
  metCondition: boolean = false;
  minimumValidConditions: number = 0;
}

export class GradReqCourseSequenceCourse {
  courseTitle?: string;
  courseID?: string;
  earnedCredits: number = 0;
}

export class RevValues {
  SRC_NAME?: string;
  V: Array<RevValue> = [];
}

export class RevRow {
  REV_ELEMENT: Array<RevElement> = [];
}

export enum CreditType {
  CourseHistory = 1,
  Grading = 2,
  Scheduled = 3,
  NYRSchedule = 4,
  Requested = 5,
  Error = 99,
}

export class RevValue {
  ID?: string;
  text?: string;
}
